module.exports = __webpack_public_path__ + "img/DangerousOutlined.88ce2a43.svg";